import type { TextMaterialCategory, TextMaterialCategoryTranslation, UpdateTextMaterialCategoryInput } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'
import { TEXT_CATEGORY } from '@hive/status'

import { mergeLeft } from 'merge-left-utils'


export interface TextMaterialCategoryFormState {
  id?: GQL_ID
  name: string
  title: string
  slug?: string
  status: string
  parend_id?: GQL_ID
  activeFrom?: Date
  activeUntil?: Date
  priority_weight?: number
  languages: string[]
  i18n: TextMaterialCategoryTranslation[]
  color?: string
}

export const TEXT_MATERIAL_CATEGORY_DEFAULT_STATE: TextMaterialCategoryFormState = {
  id: undefined,
  name: '',
  title: '',
  slug: '',
  status: TEXT_CATEGORY.DISABLED,
  parend_id: undefined,
  activeFrom: undefined,
  activeUntil: undefined,
  priority_weight: 0,
  languages: [ 'ru', 'kk' ],
  i18n: [],
  color: undefined
}

export const makeTextMaterialCategoryFormState = (
  textMaterialCategory?: TextMaterialCategory
): TextMaterialCategoryFormState => {
  const activeLanguages = textMaterialCategory?.i18n?.map(({ languageCode }) => languageCode) || [ 'ru', 'kk' ]
  return mergeLeft<TextMaterialCategoryFormState>(TEXT_MATERIAL_CATEGORY_DEFAULT_STATE, {
    ...textMaterialCategory,
    languages: activeLanguages,
    activeFrom: textMaterialCategory?.activeFrom ? new Date(textMaterialCategory.activeFrom) : undefined,
    activeUntil: textMaterialCategory?.activeUntil ? new Date(textMaterialCategory.activeUntil) : undefined
  })
}

export const mapStateToApiVariable = (state: TextMaterialCategoryFormState): UpdateTextMaterialCategoryInput => {
  const { languages, ...rest } = state
  
  return {
    ...rest,
    activeFrom: state.activeFrom?.getTime(), 
    activeUntil: state.activeUntil?.getTime(),
    priority_weight: Number(state.priority_weight) || 0
  }
}

export const mapApiDataToState = (data: TextMaterialCategory): TextMaterialCategoryFormState => {
  const activeLanguages = data?.i18n.map(({ languageCode }) => languageCode) || [ 'ru', 'kk' ]
  
  
  return {
    ...data,
    languages: data.i18n?.length > 0 ? data.i18n.map(({ languageCode }) => languageCode) : [ 'ru', 'kk' ],
    activeFrom: data.activeFrom ? new Date(data.activeFrom) : undefined,
    activeUntil: data.activeUntil ? new Date(data.activeUntil) : undefined,
    i18n: data?.i18n ? data.i18n?.map(({ languageCode, title }) => ({
      languageCode,
      title
    })) : activeLanguages?.map((languageCode) => ({
      languageCode,
      title: ''
    }))
  }
}
